import { render } from "./IconCloseThin.vue?vue&type=template&id=0ed26e12"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCloseThin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ed26e12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ed26e12', __exports__)) {
    api.reload('0ed26e12', __exports__)
  }
  
  module.hot.accept("./IconCloseThin.vue?vue&type=template&id=0ed26e12", () => {
    api.rerender('0ed26e12', render)
  })

}


export default __exports__